exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.col1[data-v-773f3364] {\n  width: 240px;\n}\n.col1r[data-v-773f3364] {\n  width: 320px;\n  padding-left: 40px;\n}\n.col2[data-v-773f3364] {\n  width: 140px;\n  text-align: right;\n  font-weight: bold;\n}\n", ""]);

// exports
